<template>
  <div class="pre">
    <div class="pre_right">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/prescription' }"
          >经典药方</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ detail.chinese_name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="prer">
        <div class="prer_lr">
          <div class="txt">
            <h2>{{ jdname }}</h2>
            <br />
            <span>【治疗】</span><br />
            <span>{{ detail.indication }}</span>
            <br />
            <span>【成分】</span><br />
            <span>{{ detail.composition  }}</span>
            <br />
            <span>【使用方法】</span><br />
            <span>{{ detail.use_method }}</span>
            <br>
            <span>【来历】</span><br />
            <span>{{ detail.references }}</span>
          </div>
          <el-button
            class="btn"
            type="success"
            v-if="detail.IsPay==false"
            @click="buyPrescri"
            >购买完整药方<i class="el-icon-right el-icon--right"></i
          ></el-button>
          <transition name="fade">
            <div class="modal" v-if="showModal">
              <div class="modal-content">
                <div class="title">
                  <!-- <img src="../Home/img/微信支付.png" alt=""> -->
                  <span>江南药镇收银台</span>
                </div>
                <div class="tab-container">
                  <div
                    class="tab"
                    :class="['tab', { active: activeTab === 0 }]"
                    @click="changeTab(0)"
                  >
                    微信支付
                  </div>
                  <!-- <div
                  class="tab"
                  :class="['tab', { active: activeTab === 1 }]"
                  @click="changeTab(1)"
                  >
                  储蓄卡
                  </div>
                  <div
                  class="tab"
                  :class="['tab', { active: activeTab === 2 }]"
                  @click="changeTab(2)"
                  >
                  信用卡
                  </div> -->
                  <div
                    class="tab"
                    :class="['tab', { active: activeTab === 3 }]"
                    @click="changeTab(3)"
                  >
                    第三方
                  </div>
                </div>
                <div class="content-container">
                  <div v-show="activeTab === 0" class="content">
                    <div class="wePay">
                      <img src="../Home/img/WePayLogo.png" alt="" />
                    </div>
                    <div class="erweima">
                      <img class="image-top" :src="imageData" />
                      <img
                        class="image-bottom"
                        src="../Home/img/说明文字.png"
                      />
                    </div>
                  </div>
                  <!-- <div v-show="activeTab === 1">
                  </div>
                  <div v-show="activeTab === 2">
                  </div> -->
                  <div v-show="activeTab === 3" class="content">
                    <p>开发中.....</p>
                  </div>
                </div>
                <button class="closbtn" @click="colsepay">关闭</button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VUE_APP_IMG_URL } from "@/config";
import { toLogin } from "@/utils";
import { mapGetters, onBeforeUnmount} from "vuex";
export default {
  data() {
    return {
      id: "",
      jdname: "",
      detail: "",
      rxlist: [],
      imgUrl: "",
      showModal: false,
      imageData: null,
      activeTab: 0,
      OrderNo:'',
      intervalId: null,
      Timeout:null,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "userId", "device"]),
  },
  watch: {},
  created: function () {
    this.imgUrl = VUE_APP_IMG_URL;
  },
  beforeUnmount() {
    clearInterval(this.Timeout);
    clearInterval(this.intervalId);
  },
  mounted: function () {
    if (typeof this.$route.query.id != "undefined") {
      this.id = this.$route.query.id;
      this.jdname = this.$route.query.jdname;
      this.GetJDInfo();
      // console.log(userInfo);
    }
    this.getRXProductList();
  },
  methods: {
    toDetail() {
      this.$router.push("/prescriptionDetail");
    },
    toLogin() {
      toLogin(this);
    },
    getRXProductList() {
      var that = this;
      that
        .$post("GetRXProductList", {
          page: 0,
        })
        .then(function (res) {
          that.rxlist = res.data.ResultData;
          for (var i in that.rxlist) {
            that.rxlist[i].Pic = that.rxlist[i].Pic.split(",")[0];
          }
        });
    },
    changeTab(index) {
          this.activeTab = index;
    },
    async buyPrescri() {
      this.showModal = true;
      this.SaveJDOrder();
    },
    async SaveJDOrder() {
      let res = await this.$post("SaveJDOrder",{JDId: this.id,PayMethed: 3});
      console.log(res, "res");
      this.OrderNo =res.data.ResultData.OrderNo;
      let res1 = await this.$post("payment_Details", { OrderNO: this.OrderNo,PayMethed: 3 }, { responseType: "arraybuffer"})
      let arrayBuffer = res1.data; 
      console.log(res1,'res111');
      let uint8Array = new Uint8Array(arrayBuffer);
      let base64String = btoa(String.fromCharCode.apply(null, uint8Array));
      this.imageData = "data:image/png;base64," + base64String;
      console.log(base64String,'base');
      this.Timeout = setTimeout(() => {
        this.intervalId = setInterval(() => {
          this.OrderState();
          // if (stopExecution) {
          //   clearInterval(this.intervalId);
          // }
        }, 1000);
        setTimeout(() => {
          clearInterval(this.intervalId);
        }, 180000);
      }, 5000);
    },
    async GetJDInfo() {
      console.log(this.id, "id");
      var res = await this.$post("GetJDInfo", { id: this.id });
      clearInterval(this.intervalId); 
      clearInterval(this.Timeout); 

      console.log(res, "GetJDInfo");
      this.detail = res.data.ResultData;
      this.jdname = res.data.ResultData.chinese_name;
    },
    async OrderState(){
      var res = await this.$post("getOrder_Detail",{OrderNo:this.OrderNo});
      console.log(res,'res');
      this.state = res.data.ResultData.OrderState;
      if(this.state != 1){
        clearInterval(this.intervalId);
        this.$router.push({
					path: '/paysuccess',
					query: {
						OrderNo: this.OrderNo,
            JdId:this.id
					}
				})
      }
    },
    colsepay(){
      this.showModal = false;
      clearInterval(this.intervalId);
      clearInterval(this.Timeout);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  >
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.title{
  font-size: 26px;
  margin: 10px 20px;
}
.modal-content {
  width: 50%;
  /* background-color: #fff; */
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.2);
}
.pre {
  width: 100%;
  height: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  background-position: center;
}
.prer {
  margin-top: 15px;
  width: 970px;
  min-height: 520px;
  box-sizing: border-box;
  background-color: #fff;
  background-image: url("../Home/img/包图网_18243549中国风复古金色边框.png");
  background-size: 100% 100%;
  background-position: center;
  border-radius: 50px;
  line-height: 30px;
  display: flex;
  flex-direction: column;
}
.prer_lr {
  width: 100%;
  min-height: 520px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.txt {
  width: 80%;
  color: #949494;
  margin-top: 70px;
  height: 399px;
  overflow-y: auto;

}
.txt h2 {
  text-align: center;
  margin:20px 0;
}
.txt span {
  font-size: 1.2em;
  letter-spacing: 2px;
}
.btn {
  width: 200px;
  height: 50px;
  color: #fff;
  font-size: 1.5em;
  background-color: #bb2524;
  border-color: #bb2524;
}

.pre_right {
  margin: 0 auto;
  padding-top: 15px;
  margin-bottom: 31px;
}
.tab-container {
  display: flex;
  margin: 20px 0 0 20px;
}

.tab {
  padding: 10px 20px;
  background-color: #ccc;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  border: 1px solid #9a9a9a;
  color: #000;
  cursor: pointer;
}

.tab.active {
  background-color: #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  z-index: 2;
}
.content-container {
  margin-left: 20px;
}
.content {
  padding: 20px;
  width: 70%;
  background-color: #f0f0f0;
  min-height: 200px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.wePay{
  width: 150px;
  height: 40px;
  float: left;
}
.closbtn{
  background-color: #fff;
  float: right;
  border: 1px solid #2b2b2b;
  padding: 5px 10px;
  border-radius: 10px;
}
.wePay img{
  width: 100%;
  height: 100%;
}
.erweima {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.erweima .image-top,
.erweima .image-bottom {
  max-width: 133px; 
  margin-top: 10px;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>